//Blank Stripo-compatible starter template (esd- markup) ported from GMS StripoV2.
//Feeding the editor HTML without this markup makes every block locked/non-editable.
export const blankTemplateHtml = `<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
            <html xmlns="http://www.w3.org/1999/xhtml" xmlns:o="urn:schemas-microsoft-com:office:office">

            <head>
                <meta charset="UTF-8">
                <meta content="width=device-width, initial-scale=1" name="viewport">
                <meta name="x-apple-disable-message-reformatting">
                <meta http-equiv="X-UA-Compatible" content="IE=edge">
                <meta content="telephone=no" name="format-detection">
                <title></title>
                <!--[if (mso 16)]>
                <style type="text/css">
                a {text-decoration: none;}
                </style>
                <![endif]-->
                <!--[if gte mso 9]><style>sup { font-size: 100% !important; }</style><![endif]-->
                <!--[if gte mso 9]>
            <xml>
                <o:OfficeDocumentSettings>
                <o:AllowPNG></o:AllowPNG>
                <o:PixelsPerInch>96</o:PixelsPerInch>
                </o:OfficeDocumentSettings>
            </xml>
            <![endif]-->
            </head>

            <body>
                <div class="es-wrapper-color">
                    <!--[if gte mso 9]>
                        <v:background xmlns:v="urn:schemas-microsoft-com:vml" fill="t">
                            <v:fill type="tile" color="#f6f6f6"></v:fill>
                        </v:background>
                    <![endif]-->
                    <table class="es-wrapper" width="100%" cellspacing="0" cellpadding="0">
                        <tbody>
                            <tr>
                                <td class="esd-email-paddings" valign="top">
                                    <table class="esd-header-popover es-header" cellspacing="0" cellpadding="0" align="center">
                                        <tbody>
                                            <tr>
                                                <td class="esd-stripe" align="center">
                                                    <table class="es-header-body" width="600" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center">
                                                        <tbody>
                                                            <tr>
                                                                <td class="es-p20t es-p20r es-p20l esd-structure" align="left">
                                                                    <!--[if mso]><table width="560" cellpadding="0"
                                        cellspacing="0"><tr><td width="180" valign="top"><![endif]-->
                                                                    <table class="es-left" cellspacing="0" cellpadding="0" align="left">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td class="es-m-p0r es-m-p20b esd-container-frame" width="180" valign="top" align="center">
                                                                                    <table width="100%" cellspacing="0" cellpadding="0">
                                                                                        <tbody>
                                                                                            <tr>
                                                                                                <td class="esd-empty-container" style="display: none;" align="center"></td>
                                                                                            </tr>
                                                                                        </tbody>
                                                                                    </table>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                    <!--[if mso]></td><td width="20"></td><td width="360" valign="top"><![endif]-->
                                                                    <table class="es-right" cellspacing="0" cellpadding="0" align="right">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td class="esd-container-frame" width="360" align="left">
                                                                                    <table width="100%" cellspacing="0" cellpadding="0">
                                                                                        <tbody>
                                                                                            <tr>
                                                                                                <td class="esd-empty-container" style="display: none;" align="center"></td>
                                                                                            </tr>
                                                                                        </tbody>
                                                                                    </table>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                    <!--[if mso]></td></tr></table><![endif]-->
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table class="es-content" cellspacing="0" cellpadding="0" align="center">
                                        <tbody>
                                            <tr>
                                                <td class="esd-stripe" align="center">
                                                    <table class="es-content-body" width="600" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center">
                                                        <tbody>
                                                            <tr>
                                                                <td class="es-p20t es-p20r es-p20l esd-structure" align="left">
                                                                    <table width="100%" cellspacing="0" cellpadding="0">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td class="esd-container-frame" width="560" valign="top" align="center">
                                                                                    <table width="100%" cellspacing="0" cellpadding="0">
                                                                                        <tbody>
                                                                                            <tr>
                                                                                                <td class="esd-empty-container" style="display: none;" align="center"></td>
                                                                                            </tr>
                                                                                        </tbody>
                                                                                    </table>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <table class="esd-footer-popover es-footer" cellspacing="0" cellpadding="0" align="center">
                                        <tbody>
                                            <tr>
                                                <td class="esd-stripe" align="center">
                                                    <table class="es-footer-body" width="600" cellspacing="0" cellpadding="0" bgcolor="#ffffff" align="center">
                                                        <tbody>
                                                            <tr>
                                                                <td class="esd-structure es-p20t es-p20b es-p20r es-p20l" align="left">
                                                                    <!--[if mso]><table width="560" cellpadding="0"
                                    cellspacing="0"><tr><td width="270" valign="top"><![endif]-->
                                                                    <table class="es-left" cellspacing="0" cellpadding="0" align="left">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td class="es-m-p20b esd-container-frame" width="270" align="left">
                                                                                    <table width="100%" cellspacing="0" cellpadding="0">
                                                                                        <tbody>
                                                                                            <tr>
                                                                                                <td class="esd-empty-container" style="display: none;" align="center"></td>
                                                                                            </tr>
                                                                                        </tbody>
                                                                                    </table>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                    <!--[if mso]></td><td width="20"></td><td width="270" valign="top"><![endif]-->
                                                                    <table class="es-right" cellspacing="0" cellpadding="0" align="right">
                                                                        <tbody>
                                                                            <tr>
                                                                                <td class="esd-container-frame" width="270" align="left">
                                                                                    <table width="100%" cellspacing="0" cellpadding="0">
                                                                                        <tbody>
                                                                                            <tr>
                                                                                                <td class="esd-empty-container" style="display: none;" align="center"></td>
                                                                                            </tr>
                                                                                        </tbody>
                                                                                    </table>
                                                                                </td>
                                                                            </tr>
                                                                        </tbody>
                                                                    </table>
                                                                    <!--[if mso]></td></tr></table><![endif]-->
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </body>

            </html>`;

export const blankTemplateCss = `.es-menu td,
            img {
                border: 0;
            }
            
            .es-menu td a,
            img {
                display: block;
            }
            
            .es-menu td a,
            body,
            h1,
            h2,
            h3,
            h4,
            h5,
            ol li,
            p,
            ul li {
                font-family: arial, 'helvetica neue', helvetica, sans-serif;
            }
            
            .es-footer,
            .es-header,
            .es-wrapper {
                background-repeat: repeat;
                background-position: center top;
            }
            
            h1,
            h2,
            h3 {
                color: #333;
            }
            
            #outlook a {
                padding: 0;
            }
            
            .es-button {
                mso-style-priority: 100 !important;
                text-decoration: none !important;
            }
            
            a[x-apple-data-detectors] {
                color: inherit !important;
                text-decoration: none !important;
                font-size: inherit !important;
                font-family: inherit !important;
                font-weight: inherit !important;
                line-height: inherit !important;
            }
            
            .es-menu td a,
            img {
                text-decoration: none;
            }
            
            a.es-button,
            button.es-button,
            h1,
            h2,
            h3 {
                font-weight: 400;
                font-style: normal;
            }
            
            .es-desk-hidden {
                display: none;
                float: left;
                overflow: hidden;
                width: 0;
                max-height: 0;
                line-height: 0;
                mso-hide: all;
            }
            
            body {
                width: 100%;
                -webkit-text-size-adjust: 100%;
                -ms-text-size-adjust: 100%
            }
            
            table {
                mso-table-lspace: 0pt;
                mso-table-rspace: 0pt;
                border-collapse: collapse;
                border-spacing: 0px;
            }
            
            .es-wrapper,
            body,
            table td {
                padding: 0;
                margin: 0;
            }
            
            .es-content,
            .es-footer,
            .es-header {
                table-layout: fixed !important;
                width: 100%;
            }
            
            img {
                outline: 0;
                -ms-interpolation-mode: bicubic;
            }
            
            hr,
            p {
                margin: 0;
            }
            
            h1,
            h2,
            h3,
            h4,
            h5 {
                Margin: 0;
                line-height: 120%;
                mso-line-height-rule: exactly;
            }
            
            a,
            ol li,
            p,
            ul li {
                -webkit-text-size-adjust: none;
                -ms-text-size-adjust: none;
                mso-line-height-rule: exactly;
            }
            
            .es-left {
                float: left;
            }
            
            .es-right {
                float: right;
            }
            
            .es-p5 {
                padding: 5px;
            }
            
            .es-p5t {
                padding-top: 5px;
            }
            
            .es-p5b {
                padding-bottom: 5px;
            }
            
            .es-p5l {
                padding-left: 5px;
            }
            
            .es-p5r {
                padding-right: 5px;
            }
            
            .es-p10 {
                padding: 10px;
            }
            
            .es-p10t {
                padding-top: 10px;
            }
            
            .es-p10b {
                padding-bottom: 10px;
            }
            
            .es-p10l {
                padding-left: 10px;
            }
            
            .es-p10r {
                padding-right: 10px;
            }
            
            .es-p15 {
                padding: 15px;
            }
            
            .es-p15t {
                padding-top: 15px;
            }
            
            .es-p15b {
                padding-bottom: 15px;
            }
            
            .es-p15l {
                padding-left: 15px;
            }
            
            .es-p15r {
                padding-right: 15px;
            }
            
            .es-p20 {
                padding: 20px;
            }
            
            .es-p20t {
                padding-top: 20px;
            }
            
            .es-p20b {
                padding-bottom: 20px;
            }
            
            .es-p20l {
                padding-left: 20px;
            }
            
            .es-p20r {
                padding-right: 20px;
            }
            
            .es-p25 {
                padding: 25px;
            }
            
            .es-p25t {
                padding-top: 25px;
            }
            
            .es-p25b {
                padding-bottom: 25px;
            }
            
            .es-p25l {
                padding-left: 25px;
            }
            
            .es-p25r {
                padding-right: 25px;
            }
            
            .es-p30 {
                padding: 30px;
            }
            
            .es-p30t {
                padding-top: 30px;
            }
            
            .es-p30b {
                padding-bottom: 30px;
            }
            
            .es-p30l {
                padding-left: 30px;
            }
            
            .es-p30r {
                padding-right: 30px;
            }
            
            .es-p35 {
                padding: 35px;
            }
            
            .es-p35t {
                padding-top: 35px;
            }
            
            .es-p35b {
                padding-bottom: 35px;
            }
            
            .es-p35l {
                padding-left: 35px;
            }
            
            .es-p35r {
                padding-right: 35px;
            }
            
            .es-p40 {
                padding: 40px;
            }
            
            .es-p40t {
                padding-top: 40px;
            }
            
            .es-p40b {
                padding-bottom: 40px;
            }
            
            .es-p40l {
                padding-left: 40px;
            }
            
            .es-p40r {
                padding-right: 40px;
            }
            
            .es-menu td a img {
                display: inline-block !important;
                vertical-align: middle;
            }
            
            s {
                text-decoration: line-through;
            }
            
            ol li,
            p,
            ul li {
                line-height: 150%;
            }
            
            ol li,
            ul li {
                Margin-bottom: 15px;
                margin-left: 0;
            }
            
            a {
                text-decoration: underline;
            }
            
            .es-wrapper {
                width: 100%;
                height: 100%;
            }
            
            .es-wrapper,
            .es-wrapper-color {
                background-color: #f6f6f6;
            }
            
            .es-footer,
            .es-header {
                background-color: transparent;
            }
            
            .es-button-border,
            a.es-button,
            button.es-button {
                background: #fff;
                display: inline-block;
                width: auto;
            }
            
            .es-content-body,
            .es-footer-body,
            .es-header-body {
                background-color: #fff;
            }
            
            .es-content-body ol li,
            .es-content-body p,
            .es-content-body ul li,
            .es-footer-body ol li,
            .es-footer-body p,
            .es-footer-body ul li,
            .es-header-body ol li,
            .es-header-body p,
            .es-header-body ul li {
                color: #333;
                font-size: 14px;
            }
            
            .es-content-body a,
            .es-header-body a {
                color: #2cb543;
                font-size: 14px;
            }
            
            .es-footer-body a {
                color: #fff;
                font-size: 14px;
            }
            
            .es-infoblock,
            .es-infoblock ol li,
            .es-infoblock p,
            .es-infoblock ul li {
                line-height: 120%;
                font-size: 12px;
                color: #ccc;
            }
            
            .es-content-body h1 a,
            .es-footer-body h1 a,
            .es-header-body h1 a,
            h1 {
                font-size: 30px;
            }
            
            .es-infoblock a {
                font-size: 12px;
                color: #ccc;
            }
            
            h2 {
                font-size: 24px;
            }
            
            h3 {
                font-size: 20px;
            }
            
            .es-content-body h2 a,
            .es-footer-body h2 a,
            .es-header-body h2 a {
                font-size: 24px;
            }
            
            .es-content-body h3 a,
            .es-footer-body h3 a,
            .es-header-body h3 a {
                font-size: 20px;
            }
            
            a.es-button,
            button.es-button {
                padding: 10px 20px;
                border-radius: 0;
                font-size: 16px;
                font-family: 'times new roman', times, baskerville, georgia, serif;
                line-height: 120%;
                color: #00e;
                text-decoration: none;
                text-align: center;
                mso-padding-alt: 0;
                mso-border-alt: 10px solid #ffffff;
            }
            
            .es-button-border {
                border: 2px solid #000;
                border-radius: 0;
            }
            
            @media only screen and (max-width:600px) {
            
                .adapt-img,
                .es-adapt-td,
                .es-adaptive table,
                .es-left,
                .es-right {
                    width: 100% !important;
                }
            
                a,
                ol li,
                p,
                ul li {
                    line-height: 150% !important;
                }
            
                h1,
                h1 a,
                h2,
                h2 a,
                h3,
                h3 a {
                    line-height: 120% !important;
                }
            
                .es-content-body h1 a,
                .es-footer-body h1 a,
                .es-header-body h1 a,
                h1 {
                    font-size: 30px !important;
                }
            
                .es-content-body h2 a,
                .es-footer-body h2 a,
                .es-header-body h2 a,
                h2 {
                    font-size: 24px !important;
                }
            
                .es-content-body h3 a,
                .es-footer-body h3 a,
                .es-header-body h3 a,
                h3 {
                    font-size: 20px !important;
                }
            
                .es-content-body a,
                .es-content-body ol li,
                .es-content-body p,
                .es-content-body ul li,
                .es-footer-body a,
                .es-footer-body ol li,
                .es-footer-body p,
                .es-footer-body ul li,
                .es-header-body a,
                .es-header-body ol li,
                .es-header-body p,
                .es-header-body ul li,
                .es-menu td a {
                    font-size: 14px;
                }
            
                .es-infoblock a,
                .es-infoblock ol li,
                .es-infoblock p,
                .es-infoblock ul li {
                    font-size: 12px;
                }
            
                .es-hidden,
                .es-mobile-hidden,
                [class=gmail-fix] {
                    display: none !important;
                }
            
                .es-m-txt-c,
                .es-m-txt-c h1,
                .es-m-txt-c h2,
                .es-m-txt-c h3 {
                    text-align: center !important;
                }
            
                .es-m-txt-r,
                .es-m-txt-r h1,
                .es-m-txt-r h2,
                .es-m-txt-r h3 {
                    text-align: right !important;
                }
            
                .es-m-txt-l,
                .es-m-txt-l h1,
                .es-m-txt-l h2,
                .es-m-txt-l h3 {
                    text-align: left !important;
                }
            
                .es-m-txt-c img,
                .es-m-txt-l img,
                .es-m-txt-r img {
                    display: inline !important;
                }
            
                .es-button-border,
                table.es-social,
                table.es-social td {
                    display: inline-block !important;
                }
            
                a.es-button,
                button.es-button {
                    font-size: 18px;
                    display: inline-block;
                }
            
                .es-content,
                .es-content table,
                .es-footer,
                .es-footer table,
                .es-header,
                .es-header table {
                    width: 100% !important;
                    max-width: 600px !important;
                }
            
                .es-adapt-td {
                    display: block !important;
                }
            
                .es-desk-hidden,
                tr.es-desk-hidden {
                    display: table-row !important;
                }
            
                .adapt-img {
                    height: auto !important;
                }
            
                .es-m-p0 {
                    padding: 0 !important;
                }
            
                .es-m-p0r {
                    padding-right: 0 !important;
                }
            
                .es-m-p0l {
                    padding-left: 0 !important;
                }
            
                .es-m-p0t {
                    padding-top: 0 !important;
                }
            
                .es-m-p0b {
                    padding-bottom: 0 !important;
                }
            
                .es-m-p20b {
                    padding-bottom: 20px !important;
                }
            
                table.es-desk-hidden,
                td.es-desk-hidden,
                tr.es-desk-hidden {
                    width: auto !important;
                    overflow: visible !important;
                    float: none !important;
                    max-height: inherit !important;
                    line-height: inherit !important;
                }
            
                table.es-desk-hidden {
                    display: table !important;
                }
            
                td.es-desk-menu-hidden {
                    display: table-cell !important;
                }
            
                .es-menu td {
                    width: 1% !important;
                }
            
                .es-desk-hidden,
                .esd-block-html table,
                table.es-table-not-adapt {
                    width: auto !important;
                }
            
                .es-desk-hidden {
                    overflow: visible !important;
                    max-height: inherit !important;
                }
            }`;
